import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import CumStats from "./Components/CumStats";
import TradeHistory from "./Components/TradeHistory";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import { AsyncContent } from "../../Components/AsyncState";

export default function TradeDetail() {
  const { accountId } = useParams();
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchAccountData = async () => {
    setLoading(true); setError("");
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/trading/accounts/${accountId}/details`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/trading/accounts/${accountId}/details`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
      setError("خطا در دریافت جزئیات معاملات");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAccountData();
  }, []);

  return (
    <LayoutPage
      activeIndex={2}
      navItems={["حساب‌ها و چالش‌ها", `حساب ${accountId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["حساب در یک نگاه", "جزئیات معاملات"]}
        hrefs={[
          `/account/${accountId}/overview`,
          `/account/${accountId}/trade-detail`,
        ]}
        activeIndex={1}
      />
      <AsyncContent loading={loading} error={error} empty={!accountData} onRetry={fetchAccountData}>
      <div className="w-full h-fit flex flex-col gap-5 min-h-0 overflow-y-auto">
        <CumStats accountData={accountData} />
        <TradeHistory accountData={accountData} />
      </div>
      </AsyncContent>
    </LayoutPage>
  );
}
